import { usePublicLegalDocument } from '@/hooks/useLegalDocuments';
import LegalDocumentPage from '@/components/legal/LegalDocumentPage';

const PrivacyPolicy = () => {
  const { data: document, isLoading, error } = usePublicLegalDocument('privacy_policy');

  return (
    <LegalDocumentPage
      document={document}
      isLoading={isLoading}
      error={error}
      defaultTitle="Privacy Policy"
      defaultContent="Our privacy policy information will be available here soon."
    />
  );
};

export default PrivacyPolicy;